import './Checkout.css';
import { Grid, Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import { CartContext } from '../../store/CartContext';

import { StoreData } from '../../data/store-data';

interface Props {}

const Basket: React.FC<Props> = () => {
  const { cart } = useContext(CartContext);
  const cartSize = StoreData.getCartSize(cart);

  return (
    <div className="basket-container">
      <div className="basket-container-box">
        <div className="cart-title">
          <span className="cart-title-span">Your order</span> ({cartSize} {cartSize === 1 ? 'item' : 'items'})
        </div>
        {cart.map((item, index) => (
          <Grid container className="basket" key={index}>
            <Grid item xs={12} sm={3}>
              <img src={item.item.image} width={70} className="image" alt="item-img" />
            </Grid>
            <Grid item xs={12} sm={7} className="description">
              <Typography className="item-name">{item.item.title}</Typography>
              <div className="item-param-box">
                <div className="item-quantity">Qty {item.quantity}</div>
                <div className="item-size">Size {item.size}</div>
              </div>
              <div className="item-price">
                <span className="item-price-span">Price:</span>${(item.item.price * item.quantity).toFixed(2)}
              </div>
            </Grid>
          </Grid>
        ))}
        <div className="merchandise-container">
          <div className="merchandise-container-item">
            <div>merchandise</div>
            <div className="merchandise-container-item-price">
              ${cart.reduce((total, cartItem) => total + cartItem.quantity * cartItem.item.price, 0).toFixed(2)}
            </div>
          </div>
          <div className="merchandise-container-item">
            <div>shipping</div>
            <div className="merchandise-container-item-price">$0.00</div>
          </div>
          <div className="merchandise-container-item">
            <div>merchandise tax</div>
            <div className="merchandise-container-item-price">$0.00</div>
          </div>
          <div className="merchandise-container-item">
            <div>shipping tax</div>
            <div className="merchandise-container-item-price">$0.00</div>
          </div>
        </div>
        <div className="item-total">
          <div className="total-title">total:</div>
          <div className="total-amount" id="total-amount">
            $
            <span id="amount">
              {cart.reduce((total, cartItem) => total + cartItem.quantity * cartItem.item.price, 0).toFixed(2)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Basket;
